import { gql } from '@apollo/client';
import IncomingOrdersDetailFragment from "../../fragments/IncomingOrders/incomingOrdersFragment";

const updateIncomingOrder = gql`
  mutation UpdateIncomingOrder(
    $supplierOrderId: Int!
    $patch: OrderPatchInput
  ) {
    incomingOrders {
      updateSupplierOrder(
        supplierOrderId: $supplierOrderId
        patch: $patch
      ) {
        success
        appliedActions
        result {
          ...IncomingOrdersDetailFragment
        } 
        errorResult {
          errorCode
          errorMessage
          data {
            key
            value
          }
        }
      }
    }
  }

${IncomingOrdersDetailFragment}
`;

export default updateIncomingOrder;
